export class LevelOfDevelopmentTypes{
    id : number;
    code : string;
    name : string; 
} 